export default {
  placeInput: {
    findAPlace: 'Găsiți un loc',
    place: 'Locul',
    addRouteStop: 'Adăugați o oprire pe traseu',
    routePlace: 'Oprire traseu',
    routeDestination: 'Destinație',
    placeNameRequired: 'Numele locului este necesar',
    yourLocation: 'Locația dumneavoastră',
    couldNotDetermineYourLocation: 'Locația dumneavoastră nu a putut fi determinată. Asigurați-vă că ați primit permisiunile necesare',
    useYourLocation: 'Utilizați locația dumneavoastră curentă',
    removeInput: 'Eliminați locul/introducere',
    fromYourBrowser: 'De pe dispozitivul dumneavoastră',
    startingPlace: 'Locul de start',
    openInputOptions: 'Opțiuni de intrare deschise',
    addInput: 'Adăugați intrarea locului',
    switchCoords: 'Comutați coordonatele',
    rawCoordinate: 'Coordonate brute lat,lng',
    noPlaceFound: 'Nu au fost returnate rezultate',
    unknownSearchPlaceError: 'Eroare de căutare a unui loc necunoscut',
    approximateDistance: 'Distanța aproximativă în linie dreaptă față de centrul actual al hărții',
    pleaseTypeSomething: 'Vă rugăm să introduceți ceva pentru a căuta',
    toggleDirect: 'Comutați direct de aici până la următorul loc',
    clickOnTheMapToSelectAPlace: 'Alegeți un loc făcând clic pe o locație de pe hartă',
    clickOnTheMapBtnToPickAPlace: 'Faceți clic pe acest buton pentru a alege un loc de pe hartă pentru această intrare',
    clickToSearchAndShowResultsOnTheMap: 'Faceți clic pentru a căuta și a afișa rezultatele pe hartă',
    directions: 'Direcții',
    addStartingPlace: 'Adăugați un loc de pornire',
    fillOrRemoveInput: 'Căutați un loc sau folosiți butonul de pe hartă din dreapta',
    couldNotDetermineYourPreciseLocationUsingPreviousLocation: 'Nu a fost posibil să se stabilească locația dumneavoastră exactă. Se va folosi în schimb locația dumneavoastră anterioară',
    goToDirectionsMode: 'Faceți clic pe butonul de direcții pentru a trece la modul de rutare',
  }
}
